<template>
	<div class="relative">
		<SearchMagnifier
			class="size-5 absolute start-5 top-1/2 -translate-y-1/2 text-gray-darker pointer-events-none"
		></SearchMagnifier>
		<input
			v-model="model"
			ref="inputRef"
			type="search"
			v-bind="$attrs"
			class="form-input ps-13!"
		/>
	</div>
</template>

<script setup lang="ts">
import type { Model } from '@/types/SearchInput'
import SearchMagnifier from '@/assets/icons/search-magnifier.svg'
import { ref } from 'vue'

const model = defineModel<Model>({ required: true })

defineOptions({
	inheritAttrs: false // attrs are bind to input, not root
})

const inputRef = ref<HTMLInputElement | null>(null)

const focus = () => {
	inputRef.value?.focus()
}

defineExpose({
	focus
})
</script>

<style scoped></style>
